<ysh-flow-nav-bar>
  <ysh-button-control type="exit" position="top-left" (click)="didTapDismiss()"/>
</ysh-flow-nav-bar>
<ysh-flow-content>
  <div class="intro">
    <h2 class="intro__heading">Choose a service option:</h2>
  </div>
  <div class="body">
    @for (service of props.services; track $index) {
      <ysh-service-card 
        [title]="service.title + ' - ' + props.payerLabel(service)"
        details="{{service.stopDuration}} Minutes"
        detailsIcon="schedule"
        description="{{service.shortDescription}}"
        [selectable]="true"
        [selected]="$index === selectedIndex"
        (click)="didTapCard($index)"
      />
    }
  </div>
</ysh-flow-content>
